import { UserGradesRepositoryType, UserGradesResponseType } from '../types';

export interface IGetUserGradesUsecase {
  invoke(userId: number): Promise<UserGradesResponseType>;
}

export class GetUserGradesUsecaseImpl implements IGetUserGradesUsecase {
  constructor(private repository: UserGradesRepositoryType) {}

  invoke(): Promise<UserGradesResponseType> {
    return this.repository.getUserGrades({
      sort: 'grade',
    });
  }
}
